var React = require('react');

function ArrowBack (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.4375 14.6662H26.6668V17.3329H10.4375L17.5895 24.4849L15.7042 26.3702L5.3335 15.9996L15.7042 5.62891L17.5895 7.51424L10.4375 14.6662Z","fill":"white"}));
}

ArrowBack.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ArrowBack;

ArrowBack.default = ArrowBack;
